/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailManagementControllerGetEmailStatus200ResponseProgress } from './emailManagementControllerGetEmailStatus200ResponseProgress';
import { EmailManagementControllerGetEmailStatus200ResponseRecipientsInner } from './emailManagementControllerGetEmailStatus200ResponseRecipientsInner';


export interface EmailManagementControllerGetEmailStatus200Response { 
    emailId?: number;
    subject?: string;
    overallStatus?: string;
    progress?: EmailManagementControllerGetEmailStatus200ResponseProgress;
    recipients?: Array<EmailManagementControllerGetEmailStatus200ResponseRecipientsInner>;
}

